import React, { useContext, useEffect, useState } from "react";
import { View, Text, TouchableOpacity, TextInput } from "react-native";
import CustomButton from "../../components/button";
import InnerBoxTitle from "../../components/inner-box-title";
import InnerBox from "../../components/inner-box";
import Wrapper from "../../components/wrapper";
import { getUserInfo, storeUserInfo } from "../../utils/user";
import LoginContext from "../../hooks/loginContext";
import translations from '../../utils/translations.json';
import { TranslateText } from "../../components/translate-text";

const FirstLoginScreen = ({ setIndex }) => {
  let defaultForm = {
    user_id: "",
    full_name: "",
    hkid: "",
    hkid_bracket: "",
    phone: "",
  }
  if (process.env.NODE_ENV ==   "development") {
    defaultForm = {
      user_id: "",
      full_name: "MING LAI FONG",
      hkid: "M123",
      hkid_bracket: "5",
      phone: "12345678",
    } 
  }
  const [form, setForm] = useState(defaultForm);
  const [loading, setLoading] = useState(null);
  const { user, setUser } = useContext(LoginContext);
  const [error, setError] = useState({
    full_name: false,
    phone: false,
    hkid: false,
  });

  const storeInfo = async () => {
    setError({ full_name: false, hkid: false, phone: false });
    if (form.full_name) {
      if (form.hkid && form.hkid_bracket) {
        if (form.phone) {
          await storeUserInfo({
            full_name: form.full_name,
            phone: form.phone,
            hkid: `${form.hkid}(${form.hkid_bracket})`,
            user_id: user.id,
          });
          const fetch_user = await getUserInfo(user.id);
          setUser({...fetch_user, full_name: form.full_name});
          localStorage.setItem('user', JSON.stringify(fetch_user));
          setIndex(2);
        } else {
          setError({ ...error, phone: true });
        }
      } else {
        setError({ ...error, hkid: true });
      }
    } else {
      setError({ ...error, full_name: true });
    }
  };
  
  // useEffect(()=>{
  //   if(user){
  //     setIndex(2);
  //   }
  // })

  return (
    <Wrapper>
      <TranslateText
        style={{
          fontSize: 28,
          marginVertical: 8,
          position: "absolute",
          top: 60,
        }}
      >
        Hollo DigiACT
      </TranslateText>
      <InnerBox>
        <InnerBoxTitle
          title={translations["Tell us about you"]}
          subtitle={
            "This is so we can verify your attendance in the clinical trial."
          }
        />
        <View
          style={{ marginVertical: 8, width: "100%", paddingHorizontal: 30 }}
        >
          <TranslateText style={{ fontSize: 20 }}>Fullname</TranslateText>
          <TextInput
            placeholder="Ming Lai Fong"
            style={{
              borderBottomWidth: 1,
              padding: 12,
              color: "#000",
              placeholder: { color: "#000" },
              marginVertical: 8,
              flex: 1,
            }}
            placeholderTextColor="#7A7A7A"
            value={form.full_name}
            onChangeText={(full_name) => {
              setForm({ ...form, full_name });
            }}
          />
          {error.full_name && !form.full_name && (
            <TranslateText style={{ fontSize: 14, color: "red" }}>
              Full name cannot be empty
            </TranslateText>
          )}
        </View>
        <View
          style={{ marginVertical: 8, width: "100%", paddingHorizontal: 30 }}
        >
          <TranslateText style={{ fontSize: 20 }}>HKID</TranslateText>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <TextInput
              placeholder="Y123456"
              style={{
                borderBottomWidth: 1,
                padding: 12,
                color: "#000",
                placeholder: { color: "#000" },
                marginVertical: 8,
                flex: 1,
              }}
              placeholderTextColor="#7A7A7A"
              value={form.hkid}
              onChangeText={(hkid) => {
                setForm({ ...form, hkid });
              }}
            />
             <TranslateText>{`(`}</TranslateText>
            <TextInput
              placeholder="7"
              style={{
                textAlign: "center",
                width: "20%",
                borderBottomWidth: 1,
                padding: 12,
                color: "#000",
                placeholder: { color: "#000" },
                marginVertical: 8,
              }}
              placeholderTextColor="#7A7A7A"
              value={form.hkid_bracket}
              onChangeText={(hkid_bracket) => {
                setForm({ ...form, hkid_bracket: hkid_bracket });
              }}
            />
            <TranslateText>{`)`}</TranslateText>
          </View>
          {error.hkid && !form.hkid && (
            <TranslateText style={{ fontSize: 14, color: "red" }}>
              HKID cannot be empty
            </TranslateText>
          )}
        </View>
        <View
          style={{ marginVertical: 8, width: "100%", paddingHorizontal: 30 }}
        >
          <TranslateText style={{ fontSize: 20 }}>Phone Number</TranslateText>
          <TextInput
            placeholder="+852-12345678"
            style={{
              borderBottomWidth: 1,
              padding: 12,
              color: "#000",
              placeholder: { color: "#000" },
              marginVertical: 8,
              flex: 1,
            }}
            placeholderTextColor="#7A7A7A"
            value={form.phone}
            onChangeText={(phone) => {
              setForm({ ...form, phone });
            }}
          />
          {error.phone && !form.phone && (
            <TranslateText style={{ fontSize: 14, color: "red" }}>
              Phone number cannot be empty
            </TranslateText>
          )}
        </View>
        <TranslateText
          style={{ fontSize: 16, paddingHorizontal: 30, marginVertical: 8 }}
        >
          This data will be kept private and not shared with third parties.
        </TranslateText>
        <CustomButton title={"Next"} onPress={storeInfo} loading={loading} />
      </InnerBox>
    </Wrapper>
  );
};

export const NextButton = ({ storeInfo }) => {
  return (
    <TouchableOpacity
      onPress={() => {
        storeInfo();
      }}
      style={{
        backgroundColor: "#33CF71",
        padding: 12,
        width: "90%",
        shadowColor: "#000",
        shadowOpacity: 0.5,
        shadowRadius: 12,
        borderRadius: 20,
        shadowOffset: { height: 4 },
      }}
    >
      <View style={{ alignItems: "center" }}>
        <TranslateText style={{ color: "#FFF" }}>Next</TranslateText>
      </View>
    </TouchableOpacity>
  );
};

export default FirstLoginScreen;
